// import { Form, Formik } from 'formik';
// import { useMemo } from 'react';
// import { useTranslation } from 'react-i18next';
// import { IStepData } from '../types/interfaces';
// import * as Yup from 'yup';
// import Button from '../../../components/buttons/Button';
// import { customStyles } from '../../../utils/SelectStyles';
// import FieldWrapper from '../../../components/formInputs/FieldWrapper';

// export default function SingleOrderReject({
//   data,
//   setRejectOpen,
//   loading,
//   submitSubmission
// }: {
//   data: IStepData;
//   setRejectOpen: React.Dispatch<React.SetStateAction<boolean>>;
//   loading?: boolean;
//   submitSubmission: (values: any, setErrors: any) => void;
// }) {
//   const { t, i18n } = useTranslation();

//   const selectOptions = useMemo(() => {
//     const fields = data?.entities?.flatMap((ele) => (ele?.auto_generate_documents || !ele?.editable_by_customer ? [] : ele.fields));

//     return fields?.map((field) => ({
//       label: field.label?.[i18n.language as 'en' | 'ar'],
//       value: field.id
//     }));
//   }, [data]);

//   const validationSchema = Yup.object({}).shape({
//     field_id: Yup.string().required('This field is required'),
//     comment: Yup.string().required('This field is required')
//   });

//   return (
//     <div className="bg-white p-10 rounded-t-[0.8125rem] lg:rounded-[0.8125rem]">
//       <Formik
//         initialValues={{
//           field_id: selectOptions?.[0]?.value || '',
//           comment: ''
//         }}
//         validationSchema={validationSchema}
//         enableReinitialize
//         onSubmit={(values, { setErrors }) => {
//           submitSubmission(
//             {
//               status: 'rejected',
//               [`comments[${values?.field_id}]`]: values?.comment
//             },
//             setErrors
//           );
//         }}
//       >
//         {(formik) => (
//           <Form>
//             <h4 className="text-h3 mb-6">{t('reject_documents')}</h4>
//             {selectOptions?.length > 1 && (
//               <FieldWrapper customPadding title={t('document')} inputPlaceholder={t('document')} inputName={`field_id`} options={selectOptions} selectStyle={customStyles} select />
//             )}
//             <FieldWrapper
//               title={t('comment')}
//               inputName={'comment'}
//               inputPlaceholder={t('comment')}
//               inputError={formik.errors.comment as string}
//               inputTouched={formik.touched.comment as boolean}
//               textArea
//             />
//             <div className='buttons'>
//               <Button type={'button'} onClick={() => setRejectOpen(false)}>
//                 {t("cancel")}
//               </Button>
//               <Button loading={loading} type="submit">
//                 <span className="bold">{t("confirm")}</span>
//               </Button>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// }

import { Form, Formik, FormikProps } from 'formik';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IStepData } from '../types/interfaces';
import * as Yup from 'yup';
import Button from '../../../components/buttons/Button';
import SingleOrderRejectInputs from './SingleOrderRejectInputs';

export default function SingleOrderReject({
  data,
  setRejectOpen,
  loading,
  submitSubmission
}: {
  data: IStepData;
  setRejectOpen: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  submitSubmission: (values: any, setErrors: any) => void;
}) {
  const { t, i18n } = useTranslation();
  const formikRef = useRef<FormikProps<any> | null>(null);

  const validationSchema = Yup.object({}).shape({
    // field_id: Yup.string().required('This field is required'),
    // comment: Yup.string().required('This field is required')
  });

  const selectOptions = useMemo(() => {
    const fields = data?.entities?.flatMap((ele) => (ele?.auto_generate_documents || !ele?.editable_by_customer ? [] : ele.fields?.filter((ele) => !ele.approved)));

    return fields?.map((field) => ({
      label: field.label?.[i18n.language as 'en' | 'ar'],
      value: String(field.id)
    }));
  }, [data]);

  return (
    <div className="bg-white p-10 rounded-t-[0.8125rem] lg:rounded-[0.8125rem]">
      <Formik
        initialValues={{
          field_id: selectOptions?.[0]?.value ? [selectOptions?.[0]?.value] : [],
          comment: ''
        }}
        innerRef={formikRef}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values, { setErrors }) => {
          const adjustedValues = { ...values };
          delete adjustedValues.field_id;
          submitSubmission(
            {
              status: 'rejected',
              ...adjustedValues
            },
            setErrors
          );
        }}
      >
        <Form>
          <h4 className="text-h3 mb-6">{t('reject_documents')}</h4>
          <SingleOrderRejectInputs selectOptions={selectOptions} />
          <div className="buttons">
            <Button type={'button'} onClick={() => setRejectOpen(false)}>
              {t('cancel')}
            </Button>
            <Button loading={loading} type="submit">
              <span className="bold">{t('confirm')}</span>
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}
